export default __webpack_public_path__ + "static/media/무릉도원.8bd5e79c.svg";